import bind from 'memoize-bind';
import moment from 'moment-timezone';
import React, { Fragment, PureComponent } from 'react';

import { Button } from '@sumologic/yama-ds-components';

import css from './CalendarMonth.module.scss';
import { CalendarNavigation } from './CalendarNavigation';

interface CalendarMonthProps {
  viewValue: Date;
  onViewChange: (view: 'day' | 'month' | 'year') => void;
  onViewValueChange: (Date) => void;
}

interface CalendarMonthState {
  activeIndex: number;
}

export class CalendarMonth extends PureComponent<
  CalendarMonthProps,
  CalendarMonthState
> {
  state = { activeIndex: 0 };

  setFocus(activeIndex: number) {
    this.setState({ activeIndex });
  }

  onMonthClick(month: string) {
    const y = moment(this.props.viewValue).get('year');
    const m = moment().month(month).get('month');

    this.props.onViewValueChange(moment([y, m]).toDate());
    this.props.onViewChange('day');
  }

  renderMonth(month: string) {
    return (
      <Button
        className={css.month}
        data-sumo-test={`calendar-month-view-${month}`}
        key={month}
        onClick={() => this.onMonthClick(month)}
        size='small'
        variant='text'
      >
        {month}
      </Button>
    );
  }

  render() {
    const { viewValue, onViewChange } = this.props;
    const { activeIndex } = this.state;
    const months = moment.monthsShort();

    return (
      <Fragment>
        <div className={css.header}>
          <div className={css.monthYear}>
            <Button
              onClick={() => onViewChange('year')}
              size='small'
              variant='text'
            >
              {moment(viewValue).format('YYYY')}
            </Button>
          </div>
        </div>
        <CalendarNavigation
          activeIndex={activeIndex}
          className={css.allMonths}
          numColumns={3}
          onIndexChange={bind(this.setFocus, this)}
        >
          {months.map((month) => this.renderMonth(month))}
        </CalendarNavigation>
      </Fragment>
    );
  }
}
